// Иконки сайдбара (Heroicons outline стиль). Вынесены из Layout.tsx при
// переходе на двухуровневое меню (25.06): их используют navConfig, SidebarNav
// и сам Layout (footer/мобильная шапка).

export function SvgIcon({ children }: { children: React.ReactNode }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="flex-shrink-0"
    >
      {children}
    </svg>
  )
}

// ─── Иконки пунктов меню ──────────────────────────────────────────────────────

export const IconDashboard = () => (
  <SvgIcon>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </SvgIcon>
)

export const IconPlanning = () => (
  <SvgIcon>
    <line x1="3" y1="21" x2="21" y2="21" />
    <polyline points="3 14 8 9 12 13 21 4" />
    <polyline points="21 9 21 4 16 4" />
  </SvgIcon>
)

export const IconAnalytics = () => (
  <SvgIcon>
    <rect x="3" y="12" width="4" height="9" rx="1" />
    <rect x="10" y="7" width="4" height="14" rx="1" />
    <rect x="17" y="3" width="4" height="18" rx="1" />
  </SvgIcon>
)

export const IconClients = () => (
  <SvgIcon>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </SvgIcon>
)

export const IconRequests = () => (
  <SvgIcon>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </SvgIcon>
)

export const IconOrders = () => (
  <SvgIcon>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1Z" />
    <line x1="8" y1="8" x2="16" y2="8" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </SvgIcon>
)

export const IconProcurement = () => (
  <SvgIcon>
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </SvgIcon>
)

// Очередь квот — список с маркерами.
export const IconQueue = () => (
  <SvgIcon>
    <circle cx="4" cy="6" r="1" />
    <circle cx="4" cy="12" r="1" />
    <circle cx="4" cy="18" r="1" />
    <line x1="9" y1="6" x2="21" y2="6" />
    <line x1="9" y1="12" x2="21" y2="12" />
    <line x1="9" y1="18" x2="21" y2="18" />
  </SvgIcon>
)

// Запросы поставщикам — бумажный самолётик (отправка запроса).
export const IconSupplierRequest = () => (
  <SvgIcon>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </SvgIcon>
)

// Поставщики — грузовик (доставка от вендора).
export const IconSuppliers = () => (
  <SvgIcon>
    <rect x="1" y="3" width="15" height="13" rx="1" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2" />
    <circle cx="18.5" cy="18.5" r="2" />
  </SvgIcon>
)

// Дашборд РОЗ — спидометр/приборная панель.
export const IconGauge = () => (
  <SvgIcon>
    <path d="M3 15a9 9 0 1 1 18 0" />
    <line x1="12" y1="15" x2="16" y2="11" />
    <circle cx="12" cy="15" r="1" />
  </SvgIcon>
)

export const IconTable = () => (
  <SvgIcon>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
    <line x1="9" y1="9" x2="9" y2="21" />
  </SvgIcon>
)

export const IconBrands = () => (
  <SvgIcon>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" strokeWidth="2.5" />
  </SvgIcon>
)

export const IconExchangeRates = () => (
  <SvgIcon>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8M14 9l3 3-3 3" />
    <path d="M16 12H8M10 15l-3-3 3-3" />
  </SvgIcon>
)

// «Банк» — здание с колоннами (раздел бухгалтерии: выписки и поступления).
export const IconBank = () => (
  <SvgIcon>
    <path d="M3 10l9-6 9 6" />
    <line x1="4" y1="20" x2="20" y2="20" />
    <line x1="6" y1="10" x2="6" y2="17" />
    <line x1="10" y1="10" x2="10" y2="17" />
    <line x1="14" y1="10" x2="14" y2="17" />
    <line x1="18" y1="10" x2="18" y2="17" />
  </SvgIcon>
)

export const IconAccounts = () => (
  <SvgIcon>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </SvgIcon>
)

export const IconSettings = () => (
  <SvgIcon>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </SvgIcon>
)

export const IconDatabase = () => (
  <SvgIcon>
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v6c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
    <path d="M3 11v6c0 1.66 4.03 3 9 3s9-1.34 9-3v-6" />
  </SvgIcon>
)

export const IconFeedback = () => (
  <SvgIcon>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="15" x2="12.01" y2="15" />
  </SvgIcon>
)

export const IconCatalog = () => (
  <SvgIcon>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <line x1="9" y1="7" x2="16" y2="7" />
  </SvgIcon>
)

export const IconKnowledgeBase = () => (
  <SvgIcon>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <line x1="8" y1="7" x2="16" y2="7" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </SvgIcon>
)

export const IconNews = () => (
  <SvgIcon>
    <path d="M4 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5z" />
    <path d="M18 8h2a1 1 0 0 1 1 1v9a3 3 0 0 1-3 3" />
    <line x1="7" y1="9" x2="14" y2="9" />
    <line x1="7" y1="13" x2="14" y2="13" />
    <line x1="7" y1="17" x2="11" y2="17" />
  </SvgIcon>
)

export const IconLogout = () => (
  <SvgIcon>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </SvgIcon>
)

// Нетарифка — планшет с галочкой (проверка позиции у брокера).
export const IconCustoms = () => (
  <SvgIcon>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" />
    <polyline points="9 14 11 16 15 12" />
  </SvgIcon>
)

// Запросы брокеру — встречные стрелки (файл брокеру и его ответ).
export const IconBrokerRequests = () => (
  <SvgIcon>
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </SvgIcon>
)

// Брокеры — карточка контакта (справочник таможенных брокеров).
export const IconBrokers = () => (
  <SvgIcon>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="2" />
    <path d="M5.5 16a3.5 3.5 0 0 1 7 0" />
    <line x1="15" y1="9" x2="18" y2="9" />
    <line x1="15" y1="13" x2="18" y2="13" />
  </SvgIcon>
)

// ─── Иконки групп (верхний уровень двухуровневого меню) ───────────────────────

// Логистика — глобус (ввоз из-за рубежа).
export const IconLogistics = () => (
  <SvgIcon>
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </SvgIcon>
)

// Продажи — ценник.
export const IconSales = () => (
  <SvgIcon>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <circle cx="7" cy="7" r="1.4" />
  </SvgIcon>
)

// Справочники — стопка книг.
export const IconLibrary = () => (
  <SvgIcon>
    <path d="M4 4h6a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4z" />
    <path d="M20 4h-6a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h6z" />
  </SvgIcon>
)

// Администрирование — щит.
export const IconShield = () => (
  <SvgIcon>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </SvgIcon>
)

// Шеврон раскрытия группы.
export const IconChevron = ({ open }: { open: boolean }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`flex-shrink-0 transition-transform ${open ? 'rotate-90' : ''}`}
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
)

export function IconHamburger() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  )
}

// Квадратик «боковая панель» — кнопка свернуть/развернуть меню (как в Claude).
export function IconSidebarToggle() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <line x1="9.5" y1="4" x2="9.5" y2="20" />
    </svg>
  )
}
